import {
  Box,
  Divider,
  FormControl,
  MenuItem,
  Select,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import { CardRow, EditableCardRow } from "../../../components/common";
import { useSessionContext } from "../../../contexts/SessionContext";

import { useEffect, useState } from "react";
import { oids } from "../../../configs/Settings";
import { useOrganizationContext } from "../../../contexts/OrganizationContext";
import { GetPractitionerRole } from "../../../services/fhir";
import { useDict } from "../../../utils/useDict";
import { useFormatter } from "../../../utils/useFormatter";

interface Estado {
  id: string;
  roles: any;
  specialty: any;
  crm?: string | undefined;
  classId?: string;
}

export function CardProfessional({
  setIsEditPracititionerRolesOpen,
  setSelectPractitionerRole,
}: any) {
  const { user, roles } = useSessionContext();

  const { organization, organizationList } = useOrganizationContext();
  const [info, setInfo] = useState<Estado[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const selectedPractitionerRole = info.find((el: any) =>
    organization?.id?.includes(el.id.split("-")[0])
  );

  useEffect(() => {
    async function fetchPractitionerRoles() {
      setLoading(true);
      try {
        const practitionerRolesReponse = await GetPractitionerRole({
          practitioner: `${oids.cpf}-${user.username}`,
        });
        setInfo(
          practitionerRolesReponse.entry.map((el: any) => {
            return {
              id: el.resource.id,
              roles: el.resource.code,
              specialty: el.resource.specialty,
              classId: el.resource?.identifier?.[0]?.value,
            };
          })
        );
      } catch (error) {
        console.error("Erro ao carregar informações profissionais:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchPractitionerRoles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Stack
      sx={{
        border: "1px solid",
        borderColor: "neutral700.main",
        borderRadius: "15px",
      }}
      width="100%"
      paddingTop={2}
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        sx={{ paddingY: 3, paddingLeft: 5, paddingRight: 3 }}
        spacing={1}
      >
        <Typography width="80%" variant="h5" fontWeight="500" paddingBottom={3}>
          Informações Profissionais
        </Typography>
        <Box sx={{ minWidth: 220 }}>
          <FormControl fullWidth>
            <Select
              value={organization?.id?.split("-")[1]}
              // onChange={handleChange}
              inputProps={{ readOnly: true }}
              IconComponent={"span"}
            >
              {roles?.map((el: any) => {
                const auxOrganization = organizationList?.find(
                  (e: fhir5.BundleEntry<fhir5.Organization>) =>
                    e?.resource?.id ===
                    el?.organization?.reference?.split("/")[1]
                );
                return (
                  <MenuItem
                    value={
                      el.organization?.reference?.split("/")[1]?.split("-")[1]
                    }
                  >
                    {auxOrganization?.resource?.alias?.[0] ||
                      auxOrganization?.resource?.name ||
                      el?.organization?.display ||
                      "-"}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Box>
      </Stack>
      {/* Skeleton durante carregamento */}
      {loading ? (
        <>
          <Box sx={{ px: 5, py: 2 }}>
            <Skeleton variant="text" width={120} height={20} sx={{ mb: 0.5 }} />
            <Skeleton variant="text" width={180} height={24} />
          </Box>
          <Divider sx={{ marginLeft: 5 }} />
          <Box sx={{ px: 5, py: 2 }}>
            <Skeleton variant="text" width={80} height={20} sx={{ mb: 0.5 }} />
            <Skeleton variant="text" width={200} height={24} />
          </Box>
          <Divider sx={{ marginLeft: 5 }} />
          <Box sx={{ px: 5, py: 2 }}>
            <Skeleton variant="text" width={100} height={20} sx={{ mb: 0.5 }} />
            <Skeleton variant="text" width={160} height={24} />
          </Box>
          <Divider sx={{ marginLeft: 5 }} />
        </>
      ) : (
        <>
          <CardRow
            title="Conselho de classe"
            titleContext={useFormatter.formatConselho(
              selectedPractitionerRole?.classId || ""
            )}
          />
          <Divider sx={{ marginLeft: 5 }} />
          <CardRow
            title="Atividade"
            titleContext={selectedPractitionerRole?.roles
              .map((el: any) => useDict.roles[el?.coding[0].system])
              .join(", ")}
          />
          <Divider sx={{ marginLeft: 5 }} />
          <EditableCardRow
            title="Especialidade"
            titleContext={selectedPractitionerRole?.specialty
              ?.map((el: any) => el?.coding[0].display)
              .join(", ")}
            onClick={() => {
              setSelectPractitionerRole(selectedPractitionerRole);
              setIsEditPracititionerRolesOpen(true);
            }}
          />
          <Divider sx={{ marginLeft: 5 }} />
        </>
      )}
    </Stack>
  );
}
